import { QrCodeIcon } from '../common/icons.jsx';

/**
 * Scan method breakdown with colored bars and first-pass OCR rate.
 * @param {{ scan: { total: number, ocrAuto: number, ocrRotated: number, manual: number } }} props
 */
export default function ScanStats({ scan }) {
  if (!scan || scan.total === 0) {
    return (
      <div className="bg-white rounded-2xl p-6 shadow-sm">
        <h3 className="font-semibold text-[#0f172a] mb-2">Scans</h3>
        <p className="text-sm text-[#64748b]">Aucun scan enregistré.</p>
      </div>
    );
  }

  const firstPassRate = scan.total > 0
    ? Math.round((scan.ocrAuto / scan.total) * 100) : 0;

  const items = [
    { label: 'OCR auto', value: scan.ocrAuto, color: 'bg-[#059669]', textColor: 'text-[#059669]' },
    { label: 'OCR rotation', value: scan.ocrRotated, color: 'bg-[#1e40af]', textColor: 'text-[#1e40af]' },
    { label: 'Manuel', value: scan.manual, color: 'bg-[#f97316]', textColor: 'text-[#f97316]' },
  ];

  const max = Math.max(...items.map((i) => i.value), 1);

  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm">
      <div className="flex items-center gap-2 mb-1">
        <QrCodeIcon size={18} className="text-[#0891b2]" />
        <h3 className="font-semibold text-[#0f172a]">Scans</h3>
      </div>
      <p className="text-xs text-[#64748b] mb-3">{scan.total} scans au total</p>

      {/* First-pass rate highlight */}
      <div className="bg-gradient-to-r from-emerald-50 to-green-50 border border-emerald-200 rounded-xl p-4 mb-5">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-[#059669]">Taux OCR premier passage</span>
          <span className={`text-2xl font-bold ${
            firstPassRate >= 80 ? 'text-[#059669]' : firstPassRate >= 50 ? 'text-[#f97316]' : 'text-[#dc2626]'
          }`}>
            {firstPassRate}%
          </span>
        </div>
        <div className="w-full h-2.5 bg-emerald-200/50 rounded-full overflow-hidden mt-2">
          <div
            className="h-full bg-[#059669] rounded-full transition-all duration-500"
            style={{ width: `${firstPassRate}%` }}
          />
        </div>
        <p className="text-xs text-[#059669] mt-1.5">
          {scan.ocrAuto} / {scan.total} scans réussis du premier coup
        </p>
      </div>

      {/* Bar breakdown */}
      <div className="space-y-4">
        {items.map((item) => (
          <div key={item.label}>
            <div className="flex justify-between text-sm mb-1.5">
              <span className="text-[#0f172a] font-medium">{item.label}</span>
              <span className={`font-bold ${item.textColor}`}>
                {item.value} <span className="font-normal text-[#64748b]">
                  ({scan.total > 0 ? Math.round((item.value / scan.total) * 100) : 0}%)
                </span>
              </span>
            </div>
            <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">
              <div
                className={`h-full ${item.color} rounded-full transition-all duration-500`}
                style={{ width: `${(item.value / max) * 100}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
